import { GET_LOGGED_IN_USER_DETAILS_ACTION } from '../actions/UserActions';

const initialState = {
    email: '',
    profile_img: '',
    mobile: '',
    full_name: '',
    designation: '',
};

export function UserReducer(state = initialState, action) {
    if (action.type === GET_LOGGED_IN_USER_DETAILS_ACTION) {
        return {
            ...state,
            email: action.payload.email,
            profile_img: action.payload.img,
            mobile: action.payload.admin_mobile,
            full_name: action.payload.full_name,
            designation: action.payload.designation
        };
    }
    return state;
}
